"use client";

import { useEffect } from "react";

export default function GlobalError({ error, reset }: { error: Error & { digest?: string }; reset: () => void }) {
  useEffect(() => {
    // Logg til console (og evt senere Sentry)
    console.error("GlobalError:", error);
  }, [error]);

  return (
    <main className="mx-auto flex min-h-dvh max-w-md flex-col px-5 py-10 bg-slate-950 text-white">
      <div className="rounded-2xl border border-red-900/50 bg-red-950/30 p-5">
        <h1 className="text-lg font-semibold">App-feil</h1>
        <p className="mt-2 text-sm text-red-100 break-words whitespace-pre-wrap">
          {error?.message ?? "Ukjent feil"}
        </p>
        {error?.digest ? <p className="mt-2 text-xs text-slate-400">Digest: {error.digest}</p> : null}
        <button
          onClick={() => reset()}
          className="mt-4 w-full rounded-xl bg-blue-600 px-3 py-3 text-sm font-semibold hover:bg-blue-500"
        >
          Prøv igjen
        </button>
      </div>
    </main>
  );
}